import { request } from './request'



// 获取个人信息
export function getNews(params) {
    return request({
        url: 'personalInfo/queryInfo',
        method: 'get',
        params
    })
}
// 获取个人快递地址
export function getAddress(params) {
    return request({
        url: 'express/queryAddress',
        method: 'get',
        params
    })
}
// 根据id查询快递地址
export function queryById(params) {
    return request({
        url: '/express/queryById',
        method: 'get',
        params
    })
}
// 获取个人发票
export function getInvoice(params) {
    return request({
        url: 'invoice/queryInvoice',
        method: 'get',
        params
    })
}
// 获取证书类型
export function getSelectCertificate(params) {
    return request({
        url: 'select/queryCertificate',
        method: 'get',
        params
    })
}
// 获取专业类别
export function getSelectMajor(params) {
    return request({
        url: 'select/queryMajor',
        method: 'get',
        params
    })
}
// 获取执业范围
export function queryJob(params) {
    return request({
        url: '/select/queryJob',
        method: 'get',
        params
    })
}
// 项目分类查询
export function querySelfConfig(params) {
    return request({
        url: '/personal/querySelfConfig',
        method: 'get',
        params
    })
}
// 获取培训项目
export function queryUserProject(data) {
    return request({
        url: '/order/queryUserProject',
        method: 'post',
        data
    })
}
// 获取我的订单
export function queryUserOrder(data) {
    return request({
        url: '/order/queryUserOrder',
        method: 'post',
        data
    })
}
// 企业订单详情
export function queryOrderDetail(data) {
    return request({
        url: '/order/queryOrderDetail?orderNo=' + data,
        method: 'post',
    })
}
// 取消订单
export function cancelOrder(data) {
    return request({
        url: '/order/cancelOrder/'+ data,
        method: 'post',
    })
}
// 修改个人信息
export function postNews(data) {
    return request({
        url: 'personalInfo/editInfo',
        method: 'post',
        data
    })
}
// 修改个人密码
export function postPsw(data) {
    return request({
        url: 'user/editPassword',
        method: 'post',
        data
    })
}
// 查询用户二类学时
export function editSelfPeriod(data) {
    return request({
        url: 'personal/editSelfPeriod',
        method: 'post',
        data
    })
}
// 查询用户二类学时
export function querySelfPeriod(data) {
    return request({
        url: 'personal/querySelfPeriod',
        method: 'post',
        data
    })
}
// 根据id查询用户二类学时
export function querySelfPeriodById(params) {
    return request({
        url: 'personal/querySelfPeriodById',
        method: 'get',
        params
    })
}
// 删除用户二类学时
export function delSelfPeriod(params) {
    return request({
        url: 'personal/delSelfPeriod',
        method: 'post',
        params
    })
}
// 修改地址默认状态
export function postIsDefault(data) {
    return request({
        url: 'express/isDefault',
        method: 'post',
        params: data
    })
}
// 修改地址默认抬头
export function postInvoiceisDefaultIsDefault(data) {
    return request({
        url: 'invoice/isDefault',
        method: 'post',
        params: data
    })
}


// 图片上传 oss/postfile
export function uploadImg(data) {
    return request({
        url: 'oss/postfile',
        method: 'post',
        params: data
    })
}

// 新增证书
export function postCertificates(data) {
    return request({
        url: 'personal/addCertificates',
        method: 'post',
        data
    })
}

// 修改证书
export function editCertificates(data) {
    return request({
        url: 'personal/editCertificates',
        method: 'post',
        data
    })
}

// 删除证书
export function delCertificates(data) {
    return request({
        url: 'personal/delCertificates/' + data,
        method: 'post',
    })
}

// 新增快递
export function NewaddAddress(data) {
    return request({
        url: '/express/addAddress',
        method: 'post',
        data
    })
}
// 修改快递地址
export function editAddress(data) {
    return request({
        url: '/express/editAddress',
        method: 'post',
        data
    })
}
// 修改发票抬头
export function editInvoice(data) {
    return request({
        url: '/invoice/editInvoice',
        method: 'post',
        data
    })
}
// 新增发票抬头
export function addInvoice(data) {
    return request({
        url: '/invoice/addInvoice',
        method: 'post',
        data
    })
}
// 查询证书
export function queryCertification(data) {
    return request({
        url: '/personal/queryCertification',
        method: 'post',
        data
    })
}
// 上传论文
export function addUserPaper(data) {
    return request({
        url: '/order/addUserPaper',
        method: 'post',
        data
    })
}
// 查询我的咨询
export function selectMyGuest(data) {
    return request({
        url: '/personal/selectMyGuest',
        method: 'post',
        data
    })
}

// 查询站内通知
export function selectCustomerNoticePage(data) {
    return request({
        url: '/customerNotice/selectCustomerNoticePage',
        method: 'post',
        data
    })
}

// 根据id查询站内通知
export function selectCustomerNoticeById(data) {
    return request({
        url: '/customerNotice/selectCustomerNoticeById/'+data,
        method: 'post',
    })
}

// 学时查询
export function queryPeriod(data) {
    return request({ url: '/personal/queryPeriod', method: 'post', data })
}
// 自助服务学时查询
export function userSelfInquiryqueryPeriod(data) {
    return request({ url: '/userSelfInquiry/queryPeriod', method: 'post', data })
}
// 学分打印
export function periodExport(data) {
    return request({ url: '/personal/periodExport', method: 'post', data })
}
// 通知公告
export function getAllNotice(data) {
    return request({ url: '/queryAllNotice', method: 'post', data })
}
//获取上一次选中的发票
export function getLastOrderInvoice(data){
    return request({url:'/order/getLastOrderInvoice',method:'get'})
}